import { render, staticRenderFns } from "./DeleteQuestionPackageConfirmationDialog.vue?vue&type=template&id=596122fc"
import script from "./DeleteQuestionPackageConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionPackageConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports